(function () {
  var PICKUP_WINDOW_START = "09:00";
  var PICKUP_WINDOW_END = "17:00";
  var PICKUP_MIN_WINDOW_MINUTES = 120;
  var SAVED_SENDER_KEY = "elegantUpsLabelSender";
  var SAVED_SENDER_FIELDS = ["officeName", "contactName", "phone", "email", "senderAddress1", "senderAddress2", "senderCity", "senderState", "senderPostalCode"];

  function readSavedSender() {
    try {
      var raw = window.localStorage.getItem(SAVED_SENDER_KEY);
      var data = raw ? JSON.parse(raw) : null;
      return data && typeof data === "object" ? data : null;
    } catch (_error) {
      return null;
    }
  }

  function writeSavedSender(data) {
    try {
      window.localStorage.setItem(SAVED_SENDER_KEY, JSON.stringify(data));
    } catch (_error) {
      // Private browsing or storage disabled: the form still works without it.
    }
  }

  function clearSavedSender() {
    try {
      window.localStorage.removeItem(SAVED_SENDER_KEY);
    } catch (_error) {
      // Nothing to clear.
    }
  }

  function base64ToBlob(base64, mimeType) {
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: mimeType || "application/octet-stream" });
  }

  function showStatus(element, type, message) {
    if (!element) {
      return;
    }

    element.hidden = false;
    element.classList.remove("success", "error");
    element.classList.add(type);
    element.textContent = trimTrailingPeriod(message);
  }

  function hideStatus(element) {
    if (!element) {
      return;
    }

    element.hidden = true;
    element.textContent = "";
    element.classList.remove("success", "error");
  }

  function revealSection(element) {
    if (!element) {
      return;
    }

    window.requestAnimationFrame(function () {
      // Blocks are not focusable on their own; tabindex -1 lets focus move there for keyboard and screen reader users.
      if (!element.hasAttribute("tabindex") && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(element.tagName)) {
        element.setAttribute("tabindex", "-1");
      }

      if (typeof element.focus === "function") {
        try {
          element.focus({ preventScroll: true });
        } catch (_error) {
          element.focus();
        }
      }

      if (typeof element.scrollIntoView === "function") {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  }

  function setButtonBusy(button, isBusy) {
    if (!button) {
      return;
    }

    var label = button.querySelector("span");

    if (label && button.dataset.busyLabel) {
      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = label.textContent;
      }

      label.textContent = isBusy
        ? button.dataset.busyLabel
        : (button.dataset.defaultLabel || label.textContent);
    }

    button.disabled = isBusy;
    button.setAttribute("aria-busy", String(isBusy));
  }

  function normalizePayload(formData) {
    return {
      officeName: formData.get("officeName") || "",
      contactName: formData.get("contactName") || "",
      email: formData.get("email") || "",
      phone: formData.get("phone") || "",
      senderAddress1: formData.get("senderAddress1") || "",
      senderAddress2: formData.get("senderAddress2") || "",
      senderCity: formData.get("senderCity") || "",
      senderState: formData.get("senderState") || "",
      senderPostalCode: formData.get("senderPostalCode") || "",
      packageCount: formData.get("packageCount") || "1",
      website: formData.get("website") || ""
    };
  }

  // Shopify loads the Customer Privacy API only on request. Without it the check below
  // never passes, so no label reached GA4 (L54, 2026-10-01). Load it once when the form starts.
  function loadCustomerPrivacyApi() {
    try {
      if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {});
      }
    } catch (_error) {
      // Analytics is optional; the form works without it.
    }
  }

  // The backend sends the GA4 event only with consent and a GA client ID; when either is missing it
  // logs which one (consent off, or no _ga cookie, e.g. a blocker), without any personal data.
  function getGa4AnalyticsContext() {
    try {
      if (!window.Shopify || !window.Shopify.customerPrivacy ||
          typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed !== "function") {
        return null;
      }
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) {
        return { consent: false, clientId: "" };
      }

      var cookie = document.cookie.split(";").map(function (part) { return part.trim(); }).find(function (part) {
        return part.indexOf("_ga=") === 0;
      });
      var match = cookie && decodeURIComponent(cookie.slice(4)).match(/^GA\d+\.\d+\.(\d+\.\d+)$/);
      return { consent: true, clientId: match ? match[1] : "" };
    } catch (_error) {
      return null;
    }
  }

  function normalizePickupPayload(formData) {
    return {
      officeName: formData.get("officeName") || "",
      contactName: formData.get("contactName") || "",
      email: formData.get("email") || "",
      phone: formData.get("phone") || "",
      senderAddress1: formData.get("senderAddress1") || "",
      senderCity: formData.get("senderCity") || "",
      senderState: formData.get("senderState") || "",
      senderPostalCode: formData.get("senderPostalCode") || "",
      pickupDate: formData.get("pickupDate") || "",
      readyTime: formData.get("readyTime") || "",
      closeTime: formData.get("closeTime") || "",
      pickupPoint: formData.get("pickupPoint") || "",
      room: formData.get("room") || "",
      floor: formData.get("floor") || "",
      specialInstructions: formData.get("specialInstructions") || "",
      trackingNumber: formData.get("trackingNumber") || "",
      labelRequestId: formData.get("labelRequestId") || "",
      packageCount: formData.get("packageCount") || "1",
      website: formData.get("website") || ""
    };
  }

  async function parseResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return {};
    }
  }

  function trimTrailingPeriod(message) {
    if (typeof message !== "string") {
      return message;
    }

    return message.replace(/\.+$/, "");
  }

  // A short reference lets the lab find the request in the logs when a practice calls about an error.
  function withRequestId(message, requestId) {
    var reference = String(requestId || "").slice(0, 8);

    return reference ? message + " Reference: " + reference : message;
  }

  function deriveEndpoint(fallbackEndpoint, explicitEndpoint, fromPath, toPath) {
    if (explicitEndpoint) {
      return explicitEndpoint;
    }

    if (!fallbackEndpoint) {
      return "";
    }

    return fallbackEndpoint.replace(new RegExp(fromPath + "\\/?$"), toPath);
  }

  function derivePickupEndpoint(labelEndpoint, explicitPickupEndpoint) {
    return deriveEndpoint(labelEndpoint, explicitPickupEndpoint, "create-label", "create-pickup");
  }

  function deriveCancelPickupEndpoint(pickupEndpoint, explicitCancelPickupEndpoint) {
    return deriveEndpoint(pickupEndpoint, explicitCancelPickupEndpoint, "create-pickup", "cancel-pickup");
  }

  function deriveVoidLabelEndpoint(labelEndpoint, explicitVoidEndpoint) {
    var derived = deriveEndpoint(labelEndpoint, explicitVoidEndpoint, "create-label", "void-label");

    // A label endpoint that does not end in create-label cannot be mapped; never post a void to it.
    return derived === labelEndpoint ? "" : derived;
  }

  function getLocalDateString() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    return year + "-" + month + "-" + day;
  }

  function parseTimeToMinutes(value) {
    if (!/^([01]\d|2[0-3]):([0-5]\d)$/.test(value || "")) {
      return null;
    }

    var parts = value.split(":");
    return (Number(parts[0]) * 60) + Number(parts[1]);
  }

  function isWeekendDateString(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) {
      return false;
    }

    var parts = value.split("-").map(Number);
    var date = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    var day = date.getDay();

    return day === 0 || day === 6;
  }

  function getNextBusinessDateString(startValue) {
    var baseDate;

    if (/^\d{4}-\d{2}-\d{2}$/.test(startValue || "")) {
      var parts = startValue.split("-").map(Number);
      baseDate = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    } else {
      baseDate = new Date();
      baseDate.setHours(12, 0, 0, 0);
    }

    while (baseDate.getDay() === 0 || baseDate.getDay() === 6) {
      baseDate.setDate(baseDate.getDate() + 1);
    }

    var year = baseDate.getFullYear();
    var month = String(baseDate.getMonth() + 1).padStart(2, "0");
    var day = String(baseDate.getDate()).padStart(2, "0");

    return year + "-" + month + "-" + day;
  }

  // The first day a pickup can still be booked: today until 3:00 PM (a 2-hour window has to end by 5:00 PM),
  // later than that the next business day. Without this the form offered today's 9-to-5 window in the evening
  // and UPS refused it only after the dentist pressed the button.
  function getEarliestPickupDateString() {
    var now = new Date();
    var nowMinutes = now.getHours() * 60 + now.getMinutes();
    var lastStart = parseTimeToMinutes(PICKUP_WINDOW_END) - PICKUP_MIN_WINDOW_MINUTES;
    var day = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);

    if (nowMinutes > lastStart) {
      day.setDate(day.getDate() + 1);
    }

    return getNextBusinessDateString(day.getFullYear() + "-" + String(day.getMonth() + 1).padStart(2, "0") + "-" + String(day.getDate()).padStart(2, "0"));
  }

  function formatDurationLabel(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (hours > 0 && minutes === 0) {
      return hours + "-hour";
    }

    if (hours > 0) {
      return hours + "h " + minutes + "m";
    }

    return minutes + "-minute";
  }

  function formatClockLabel(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    var displayHours = hours % 12 === 0 ? 12 : hours % 12;

    return displayHours + ":" + String(minutes).padStart(2, "0") + " " + (hours >= 12 ? "PM" : "AM");
  }

  function getPickupGuardrailError(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return null;
    }

    var dateField = pickupForm.elements.namedItem("pickupDate");
    var readyField = pickupForm.elements.namedItem("readyTime");
    var closeField = pickupForm.elements.namedItem("closeTime");
    var today = getLocalDateString();
    var startMinutes = parseTimeToMinutes(PICKUP_WINDOW_START);
    var endMinutes = parseTimeToMinutes(PICKUP_WINDOW_END);
    var readyMinutes = parseTimeToMinutes(readyField && readyField.value);
    var closeMinutes = parseTimeToMinutes(closeField && closeField.value);

    if (dateField && dateField.value && dateField.value < today) {
      return {
        field: dateField,
        message: "Pickup date cannot be in the past."
      };
    }

    if (dateField && dateField.value && dateField.value < getEarliestPickupDateString()) {
      return {
        field: dateField,
        message: "Same-day pickups can be booked until 3:00 PM. Please choose the next business day."
      };
    }

    if (dateField && dateField.value && isWeekendDateString(dateField.value)) {
      return {
        field: dateField,
        message: "Pickups are available Monday through Friday only."
      };
    }

    if (readyField && Number.isFinite(readyMinutes) && (readyMinutes < startMinutes || readyMinutes >= endMinutes)) {
      return {
        field: readyField,
        message: "Earliest pickup time must be between 9:00 AM and 5:00 PM."
      };
    }

    if (closeField && Number.isFinite(closeMinutes) && (closeMinutes <= startMinutes || closeMinutes > endMinutes)) {
      return {
        field: closeField,
        message: "Latest pickup time must be between 9:00 AM and 5:00 PM."
      };
    }

    if (Number.isFinite(readyMinutes) && Number.isFinite(closeMinutes) && (closeMinutes - readyMinutes) < PICKUP_MIN_WINDOW_MINUTES) {
      return {
        field: closeField,
        message: "Please allow at least a " + formatDurationLabel(PICKUP_MIN_WINDOW_MINUTES) + " pickup window."
      };
    }

    // UPS also measures the window from the present moment: a same-day pickup whose latest time is
    // under two hours away is refused ("Closing time is less than the minimum window after present
    // time", a Colorado office on 2026-10-01). Check it here, rounded up to the 15-minute time step.
    if (dateField && dateField.value === today && Number.isFinite(closeMinutes)) {
      var now = new Date();
      var earliestClose = Math.ceil((now.getHours() * 60 + now.getMinutes() + PICKUP_MIN_WINDOW_MINUTES) / 15) * 15;

      if (closeMinutes < earliestClose) {
        return {
          field: closeField,
          message: "For a pickup today, choose a latest pickup time of " + formatClockLabel(earliestClose) + " or later."
        };
      }
    }

    return null;
  }

  function applyPickupFieldConstraints(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return;
    }

    var dateField = pickupForm.elements.namedItem("pickupDate");
    var readyField = pickupForm.elements.namedItem("readyTime");
    var closeField = pickupForm.elements.namedItem("closeTime");
    var today = getLocalDateString();
    var earliest = getEarliestPickupDateString();

    if (dateField) {
      dateField.min = earliest;

      if (!dateField.value || dateField.value < earliest || isWeekendDateString(dateField.value)) {
        dateField.value = earliest;
      }
    }

    if (readyField) {
      readyField.min = PICKUP_WINDOW_START;
      readyField.max = PICKUP_WINDOW_END;
      readyField.step = 900;

      if (!readyField.value) {
        readyField.value = PICKUP_WINDOW_START;
      }
    }

    if (closeField) {
      closeField.min = PICKUP_WINDOW_START;
      closeField.max = PICKUP_WINDOW_END;
      closeField.step = 900;

      if (!closeField.value) {
        closeField.value = PICKUP_WINDOW_END;
      }
    }
  }

  function syncPickupFieldValidity(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return null;
    }

    ["pickupDate", "readyTime", "closeTime"].forEach(function (fieldName) {
      var field = pickupForm.elements.namedItem(fieldName);

      if (field && typeof field.setCustomValidity === "function") {
        field.setCustomValidity("");
      }
    });

    var guardrailError = getPickupGuardrailError(pickupForm);

    if (guardrailError && guardrailError.field && typeof guardrailError.field.setCustomValidity === "function") {
      guardrailError.field.setCustomValidity(guardrailError.message);
    }

    return guardrailError;
  }

  function setFieldValue(form, name, value) {
    if (!form || !form.elements) {
      return;
    }

    const field = form.elements.namedItem(name);

    if (!field) {
      return;
    }

    field.value = value;
  }

  function revokeLabelUrls(labelUrls) {
    labelUrls.forEach(function (entry) {
      if (entry && entry.url) {
        window.URL.revokeObjectURL(entry.url);
      }
    });
  }

  function renderTrackingList(listElement, summaryElement, trackingNumbers) {
    if (!listElement || !summaryElement) {
      return;
    }

    listElement.innerHTML = "";

    trackingNumbers.forEach(function (trackingNumber) {
      const item = document.createElement("li");
      item.textContent = trackingNumber;
      listElement.appendChild(item);
    });

    summaryElement.hidden = trackingNumbers.length <= 1;
  }

  function renderLabelList(listElement, labels, onPrint, options) {
    if (!listElement) {
      return;
    }

    const settings = options || {};
    const summaryCount = settings.summaryCount || labels.length;
    const combinedDocument = Boolean(settings.combinedDocument);
    listElement.innerHTML = "";

    labels.forEach(function (entry) {
      const card = document.createElement("article");
      card.className = "ups-label-result__label-item";

      const title = document.createElement("h3");
      title.className = "ups-label-result__label-title";
      if (combinedDocument && summaryCount > 1) {
        title.textContent = "All labels";
      } else {
        title.textContent = labels.length === 1 ? "Shipping label" : "Label " + entry.packageNumber;
      }

      const tracking = document.createElement("p");
      tracking.className = "ups-label-result__label-tracking";
      tracking.textContent = trimTrailingPeriod(
        combinedDocument && summaryCount > 1
          ? "Printable file for all " + summaryCount + " labels"
          : "Tracking: " + (entry.trackingNumber || "Pending")
      );

      const actions = document.createElement("div");
      actions.className = "ups-label-result__actions";

      const download = document.createElement("a");
      download.className = "button accent";
      download.href = entry.url;
      download.target = "_blank";
      download.rel = "noopener";
      download.download = entry.fileName || ("ups-label-" + entry.packageNumber);
      if (combinedDocument && summaryCount > 1) {
        download.textContent = "Download all labels";
      } else {
        download.textContent = labels.length === 1 ? "Download label" : "Download label " + entry.packageNumber;
      }

      const printButton = document.createElement("button");
      printButton.type = "button";
      printButton.className = "button outline";
      if (combinedDocument && summaryCount > 1) {
        printButton.textContent = "Print all labels";
      } else {
        printButton.textContent = labels.length === 1 ? "Print label" : "Print label " + entry.packageNumber;
      }
      printButton.addEventListener("click", function () {
        onPrint(entry.url);
      });

      actions.appendChild(download);
      actions.appendChild(printButton);
      card.appendChild(title);
      card.appendChild(tracking);
      card.appendChild(actions);
      listElement.appendChild(card);
    });
  }

  // Reads the unsigned part of a cancel token to show what a link from an email would cancel.
  // The server still checks the signature; this is display only.
  function readCancelToken(token, prefix) {
    var parts = String(token || "").split(".");

    if (parts.length !== 3 || parts[0] !== prefix) {
      return null;
    }

    try {
      var base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");

      while (base64.length % 4) {
        base64 += "=";
      }

      var binary = window.atob(base64);
      var bytes = Uint8Array.from(binary, function (character) {
        return character.charCodeAt(0);
      });
      var data = JSON.parse(new TextDecoder().decode(bytes));

      return data && typeof data === "object" ? data : null;
    } catch (_error) {
      return null;
    }
  }

  function formatPickupDate(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));

    if (!match) {
      return "";
    }

    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric"
    });
  }

  function formatAddressDisplay(address) {
    if (!address) {
      return "";
    }

    var lines = [];

    if (address.address1) {
      lines.push(address.address1);
    }

    if (address.address2) {
      lines.push(address.address2);
    }

    var locality = "";

    if (address.city) {
      locality += address.city;
    }

    if (address.state) {
      locality += (locality ? ", " : "") + address.state;
    }

    if (address.postalCode) {
      locality += (address.state ? " " : (locality ? ", " : "")) + address.postalCode;
    }

    if (locality) {
      lines.push(locality);
    }

    return lines.join("\n");
  }

  function initSection(section) {
    const endpointUrl = (section.dataset.endpointUrl || "").trim();
    const pickupEndpointUrl = derivePickupEndpoint(endpointUrl, (section.dataset.pickupEndpointUrl || "").trim());
    const cancelPickupEndpointUrl = deriveCancelPickupEndpoint(pickupEndpointUrl, (section.dataset.cancelPickupEndpointUrl || "").trim());
    const voidLabelEndpointUrl = deriveVoidLabelEndpoint(endpointUrl, (section.dataset.voidLabelEndpointUrl || "").trim());
    const form = section.querySelector("form.ups-label-form");
    const submitButton = section.querySelector("[data-ups-submit]");
    const status = section.querySelector("[data-ups-status]");
    const addressReview = section.querySelector("[data-ups-address-review]");
    const enteredAddress = section.querySelector("[data-ups-entered-address]");
    const addressCandidates = section.querySelector("[data-ups-address-candidates]");
    const addressCandidatesLabel = section.querySelector("[data-ups-address-candidates-label]");
    const suggestedAddress = section.querySelector("[data-ups-suggested-address]");
    const useSuggestedAddressButton = section.querySelector("[data-ups-use-suggested-address]");
    const result = section.querySelector("[data-ups-result]");
    const resultEyebrow = section.querySelector("[data-ups-result-eyebrow]");
    const resultTitle = section.querySelector("[data-ups-result-title]");
    const labelCount = section.querySelector("[data-ups-label-count]");
    const trackingSummary = section.querySelector("[data-ups-tracking-summary]");
    const trackingList = section.querySelector("[data-ups-tracking-list]");
    const labelList = section.querySelector("[data-ups-label-list]");
    const pickupCard = section.querySelector("[data-ups-pickup-card]");
    const pickupForm = section.querySelector("form.ups-pickup-form");
    const pickupSubmit = section.querySelector("[data-ups-pickup-submit]");
    const pickupStatus = section.querySelector("[data-ups-pickup-status]");
    const pickupResult = section.querySelector("[data-ups-pickup-result]");
    const pickupSummary = section.querySelector("[data-ups-pickup-summary]");
    const pickupPrn = section.querySelector("[data-ups-pickup-prn]");
    const pickupChargeRow = section.querySelector("[data-ups-pickup-charge-row]");
    const pickupCharge = section.querySelector("[data-ups-pickup-charge]");
    const pickupResultEyebrow = section.querySelector("[data-ups-pickup-result-eyebrow]");
    const pickupResultTitle = section.querySelector("[data-ups-pickup-result-title]");
    const cancelPickupButton = section.querySelector("[data-ups-cancel-pickup]");
    const savedNotice = section.querySelector("[data-ups-saved]");
    const clearSavedButtons = section.querySelectorAll("[data-ups-clear-saved]");
    const returningCard = section.querySelector("[data-ups-returning]");
    const returningName = section.querySelector("[data-ups-returning-name]");
    const returningAddress = section.querySelector("[data-ups-returning-address]");
    const editDetailsButton = section.querySelector("[data-ups-edit-details]");
    const rememberCheckbox = section.querySelector("[data-ups-remember]");
    const voidBlock = section.querySelector("[data-ups-void]");
    const voidPrompt = section.querySelector("[data-ups-void-prompt]");
    const voidOpenButton = section.querySelector("[data-ups-void-open]");
    const voidConfirm = section.querySelector("[data-ups-void-confirm]");
    const voidPickupRow = section.querySelector("[data-ups-void-pickup-row]");
    const voidPickupCheckbox = section.querySelector("[data-ups-void-pickup]");
    const voidSubmit = section.querySelector("[data-ups-void-submit]");
    const voidKeepButton = section.querySelector("[data-ups-void-keep]");
    const voidStatus = section.querySelector("[data-ups-void-status]");
    const voidTitle = section.querySelector("[data-ups-void-title]");
    const voidText = section.querySelector("[data-ups-void-text]");
    const voidPickupText = section.querySelector("[data-ups-void-pickup-text]");

    if (!form) {
      return;
    }

    function enterReturning(saved) {
      if (!returningCard) {
        return;
      }

      if (returningName) {
        returningName.textContent = [saved.officeName, saved.contactName].filter(Boolean).join(" · ");
      }

      if (returningAddress) {
        returningAddress.textContent = [saved.senderAddress1, saved.senderAddress2, [saved.senderCity, [saved.senderState, saved.senderPostalCode].filter(Boolean).join(" ")].filter(Boolean).join(", ")].filter(Boolean).join(", ");
      }

      returningCard.hidden = false;
      section.classList.add("is-returning");

      if (savedNotice) {
        savedNotice.hidden = true;
      }
    }

    function leaveReturning() {
      if (returningCard) {
        returningCard.hidden = true;
      }

      section.classList.remove("is-returning");
    }

    (function prefillSavedSender() {
      var saved = readSavedSender();
      var filled = false;

      if (!saved) {
        return;
      }

      // Only a pristine form is filled, and then as a whole, so a preselected state never mixes with a saved address.
      var pristine = SAVED_SENDER_FIELDS.every(function (name) {
        var field = form.elements.namedItem(name);
        return !field || field.tagName === "SELECT" || !field.value;
      });

      if (!pristine) {
        return;
      }

      SAVED_SENDER_FIELDS.forEach(function (name) {
        var field = form.elements.namedItem(name);
        var value = typeof saved[name] === "string" ? saved[name] : "";

        if (!field || !value) {
          return;
        }

        if (field.tagName === "SELECT" && !Array.prototype.some.call(field.options, function (option) { return option.value === value; })) {
          return;
        }

        field.value = value;
        filled = true;
      });

      // Gary 2026-09-30 removed the optional Suite field; a suite saved while it existed joins the street line.
      var streetField = form.elements.namedItem("senderAddress1");
      var savedSuite = typeof saved.senderAddress2 === "string" ? saved.senderAddress2.trim() : "";

      if (!form.elements.namedItem("senderAddress2") && savedSuite && streetField && streetField.value &&
          streetField.value.toLowerCase().indexOf(savedSuite.toLowerCase()) === -1) {
        streetField.value = streetField.value + ", " + savedSuite;
      }

      if (filled && savedNotice) {
        savedNotice.hidden = false;
      }

      // A returning practice with complete details gets the short version: its card, the boxes and the button.
      var complete = SAVED_SENDER_FIELDS.every(function (name) {
        var field = form.elements.namedItem(name);
        return !field || (!field.required || field.value) && field.checkValidity();
      });

      if (filled && complete) {
        enterReturning(saved);
      }
    })();

    if (editDetailsButton) {
      editDetailsButton.addEventListener("click", function () {
        leaveReturning();

        if (savedNotice) {
          savedNotice.hidden = false;
        }

        var first = form.elements.namedItem("officeName");

        if (first && typeof first.focus === "function") {
          first.focus();
        }
      });
    }

    Array.prototype.forEach.call(clearSavedButtons, function (clearSavedButton) {
      clearSavedButton.addEventListener("click", function () {
        leaveReturning();
        clearSavedSender();
        SAVED_SENDER_FIELDS.forEach(function (name) {
          var field = form.elements.namedItem(name);

          if (!field) {
            return;
          }

          if (field.tagName === "SELECT") {
            var preset = Array.prototype.find.call(field.options, function (option) { return option.defaultSelected; });
            field.value = preset ? preset.value : "";
          } else {
            field.value = "";
          }
        });

        if (savedNotice) {
          savedNotice.hidden = true;
        }

        updatePreview();

        var first = form.elements.namedItem("officeName");

        if (first && typeof first.focus === "function") {
          first.focus();
        }
      });
    });

    // The label drawing next to the form mirrors what the practice types; display only.
    const previewFrom = section.querySelector("[data-ups-preview-from]");
    const previewBoxes = section.querySelector("[data-ups-preview-boxes]");
    const updatePreview = function () {
      var value = function (name) {
        var field = form.elements.namedItem(name);
        return field && field.value ? String(field.value).trim() : "";
      };

      if (previewBoxes) {
        var boxes = Number.parseInt(value("packageCount") || "1", 10) || 1;
        previewBoxes.textContent = boxes + (boxes === 1 ? " box" : " boxes");
      }

      if (!previewFrom) {
        return;
      }

      var typed = ["officeName", "contactName", "senderAddress1", "senderCity", "senderPostalCode"].some(function (name) {
        return value(name);
      });
      var lines = typed
        ? [
            value("officeName"),
            value("contactName") ? "Attn: " + value("contactName") : "",
            value("senderAddress1"),
            value("senderAddress2"),
            [value("senderCity"), [value("senderState"), value("senderPostalCode")].filter(Boolean).join(" ")].filter(Boolean).join(", ")
          ].filter(Boolean)
        : ["Your practice", "Street address", "City, State ZIP"];

      previewFrom.textContent = "";
      lines.forEach(function (line, index) {
        if (index) {
          previewFrom.appendChild(document.createElement("br"));
        }
        previewFrom.appendChild(document.createTextNode(line));
      });
      previewFrom.classList.toggle("is-empty", !typed);
    };

    form.addEventListener("input", updatePreview);
    form.addEventListener("change", updatePreview);
    updatePreview();

    const rememberSender = function (payload, originAddress) {
      if (!rememberCheckbox || !rememberCheckbox.checked) {
        clearSavedSender();
        return;
      }

      var address = originAddress || {};

      writeSavedSender({
        officeName: payload.officeName || "",
        contactName: payload.contactName || "",
        phone: payload.phone || "",
        email: payload.email || "",
        senderAddress1: address.address1 || payload.senderAddress1 || "",
        senderAddress2: address.address2 || payload.senderAddress2 || "",
        senderCity: address.city || payload.senderCity || "",
        senderState: address.state || payload.senderState || "",
        senderPostalCode: address.postalCode || payload.senderPostalCode || ""
      });
    };

    let labelUrls = [];
    let activeAbortController = null;
    let activePickupAbortController = null;
    let activeCancelPickupAbortController = null;
    let currentPickupPrn = "";
    let pendingAddressCandidates = [];
    let pickupActive = false;
    let currentVoidToken = "";
    let currentLabelRequestId = "";
    let currentLabelPayload = null;
    let currentOriginAddress = null;
    let currentLabelCount = 1;
    let currentPickupCancelToken = "";
    let currentLabelTrackingNumbers = [];
    const resultCheck = result ? result.querySelector(".ups-label-result__check") : null;
    const resultCheckMarkup = resultCheck ? resultCheck.innerHTML : "";

    const resetPickup = function () {
      if (pickupCard) {
        pickupCard.hidden = true;
      }

      if (pickupResult) {
        pickupResult.hidden = true;
      }

      if (pickupPrn) {
        pickupPrn.textContent = "";
      }

      currentPickupPrn = "";
      currentPickupCancelToken = "";
      pickupActive = false;

      if (pickupCharge) {
        pickupCharge.textContent = "";
      }

      if (pickupChargeRow) {
        pickupChargeRow.hidden = true;
      }

      if (cancelPickupButton) {
        cancelPickupButton.hidden = true;
      }

      if (pickupResultEyebrow) {
        pickupResultEyebrow.textContent = "Pickup scheduled";
      }

      if (pickupResultTitle) {
        pickupResultTitle.textContent = "UPS pickup request confirmed";
      }

      hideStatus(pickupStatus);
    };

    const resetAddressReview = function () {
      pendingAddressCandidates = [];

      if (addressReview) {
        addressReview.hidden = true;
      }

      if (enteredAddress) {
        enteredAddress.textContent = "";
      }

      if (suggestedAddress) {
        suggestedAddress.textContent = "";
      }

      if (addressCandidates) {
        addressCandidates.innerHTML = "";
      }
    };

    const renderAddressReview = function (payload, data) {
      if (!addressReview || !enteredAddress || !suggestedAddress || !addressCandidates) {
        return;
      }

      pendingAddressCandidates = Array.isArray(data && data.candidates) ? data.candidates.slice() : [];

      enteredAddress.textContent = formatAddressDisplay(data && data.enteredAddress ? data.enteredAddress : {
        address1: payload.senderAddress1,
        city: payload.senderCity,
        state: payload.senderState,
        postalCode: payload.senderPostalCode,
        countryCode: "US"
      });

      addressCandidates.innerHTML = "";
      pendingAddressCandidates.forEach(function (candidate, index) {
        var option = document.createElement("option");
        option.value = String(index);
        option.textContent = formatAddressDisplay(candidate).replace(/\n/g, " • ");
        addressCandidates.appendChild(option);
      });

      // One verified address needs no choice: show it without the dropdown
      var singleCandidate = pendingAddressCandidates.length <= 1;
      addressCandidates.hidden = singleCandidate;
      if (addressCandidatesLabel) {
        addressCandidatesLabel.hidden = singleCandidate;
      }

      if (pendingAddressCandidates[0]) {
        addressCandidates.value = "0";
        suggestedAddress.textContent = formatAddressDisplay(pendingAddressCandidates[0]);
      } else {
        suggestedAddress.textContent = "";
      }

      addressReview.hidden = pendingAddressCandidates.length === 0;

      if (!addressReview.hidden) {
        revealSection(addressReview);
      }
    };

    const openPrintWindow = function (url) {
      if (!url) {
        return;
      }

      const printWindow = window.open(url, "_blank", "noopener");

      if (printWindow) {
        printWindow.focus();
      }
    };

    const resetVoid = function () {
      currentVoidToken = "";
      currentLabelRequestId = "";
      currentLabelPayload = null;
      currentOriginAddress = null;

      if (result) {
        result.classList.remove("is-voided");
      }

      if (resultCheck) {
        resultCheck.innerHTML = resultCheckMarkup;
      }

      if (voidBlock) {
        voidBlock.hidden = true;
      }

      if (voidPrompt) {
        voidPrompt.hidden = false;
      }

      if (voidConfirm) {
        voidConfirm.hidden = true;
      }

      hideStatus(voidStatus);
    };

    // One label reads "this label"; two or more say plainly that all of them are cancelled together.
    const setVoidWording = function (count) {
      var many = count > 1;
      var all = count === 2 ? "both labels" : "all " + count + " labels";
      var submitText = many ? "Yes, cancel " + all : "Yes, cancel label";
      var submitLabel = voidSubmit ? voidSubmit.querySelector("span") : null;

      currentLabelCount = count;

      if (voidOpenButton) {
        voidOpenButton.textContent = many ? "Cancel these labels" : "Cancel this label";
      }

      if (voidTitle) {
        voidTitle.textContent = many ? "Cancel " + all + "?" : "Cancel this label?";
      }

      if (voidText) {
        voidText.textContent = many
          ? "UPS will void them, and the printed labels will no longer work. You can create new ones right away."
          : "UPS will void it, and the printed label will no longer work. You can create a new one right away.";
      }

      if (voidPickupText) {
        voidPickupText.textContent = "Also cancel the UPS pickup scheduled for " + (many ? "these labels" : "this label");
      }

      if (submitLabel) {
        submitLabel.textContent = submitText;
        voidSubmit.dataset.defaultLabel = submitText;
      }

      if (voidKeepButton) {
        voidKeepButton.textContent = many ? "Keep labels" : "Keep label";
      }
    };

    const resetResult = function () {
      result.hidden = true;
      if (resultEyebrow) {
        resultEyebrow.textContent = "Label created";
      }

      if (resultTitle) {
        resultTitle.textContent = "UPS label is ready";
      }

      if (labelCount) {
        labelCount.textContent = "";
      }

      if (labelList) {
        labelList.innerHTML = "";
      }

      if (trackingList) {
        trackingList.innerHTML = "";
      }

      if (trackingSummary) {
        trackingSummary.hidden = true;
      }

      resetPickup();
      resetVoid();

      revokeLabelUrls(labelUrls);
      labelUrls = [];
    };

    const primePickupForm = function (labelPayload, labelResponse) {
      if (!pickupForm || !pickupCard) {
        return;
      }

      var resolvedOriginAddress = labelResponse && labelResponse.originAddress ? labelResponse.originAddress : {
        address1: labelPayload.senderAddress1 || "",
        address2: "",
        city: labelPayload.senderCity || "",
        state: labelPayload.senderState || "",
        postalCode: labelPayload.senderPostalCode || "",
        countryCode: "US"
      };

      setFieldValue(pickupForm, "officeName", labelPayload.officeName || "");
      setFieldValue(pickupForm, "email", labelPayload.email || "");
      setFieldValue(pickupForm, "senderAddress1", resolvedOriginAddress.address1 || "");
      setFieldValue(pickupForm, "senderAddress2", resolvedOriginAddress.address2 || "");
      setFieldValue(pickupForm, "senderCity", resolvedOriginAddress.city || "");
      setFieldValue(pickupForm, "senderState", resolvedOriginAddress.state || "");
      setFieldValue(pickupForm, "senderPostalCode", resolvedOriginAddress.postalCode || "");
      setFieldValue(pickupForm, "trackingNumber", labelResponse.trackingNumber || "");
      setFieldValue(pickupForm, "labelRequestId", labelResponse.requestId || "");
      setFieldValue(pickupForm, "packageCount", String(labelResponse.packageCount || labelPayload.packageCount || 1));
      setFieldValue(pickupForm, "pickupConfirmationNumber", "");
      setFieldValue(pickupForm, "contactName", labelPayload.contactName || "");
      setFieldValue(pickupForm, "phone", labelPayload.phone || "");

      if (!pickupForm.elements.namedItem("pickupDate").value) {
        setFieldValue(pickupForm, "pickupDate", getEarliestPickupDateString());
      }

      if (!pickupForm.elements.namedItem("readyTime").value) {
        setFieldValue(pickupForm, "readyTime", "09:00");
      }

      if (!pickupForm.elements.namedItem("closeTime").value) {
        setFieldValue(pickupForm, "closeTime", "17:00");
      }

      if (!pickupForm.elements.namedItem("pickupPoint").value) {
        setFieldValue(pickupForm, "pickupPoint", "Front desk");
      }

      if (pickupSummary) {
        pickupSummary.textContent =
          (resolvedOriginAddress.address1 || "") +
          ", " +
          (resolvedOriginAddress.city || "") +
          ", " +
          (resolvedOriginAddress.state || "") +
          " " +
          (resolvedOriginAddress.postalCode || "");
      }

      pickupCard.hidden = false;
      applyPickupFieldConstraints(pickupForm);
      syncPickupFieldValidity(pickupForm);
    };

    if (pickupForm) {
      const pickupDateField = pickupForm.elements.namedItem("pickupDate");

      if (pickupDateField && !pickupDateField.value) {
        pickupDateField.value = getEarliestPickupDateString();
      }

      applyPickupFieldConstraints(pickupForm);
      syncPickupFieldValidity(pickupForm);

      ["pickupDate", "readyTime", "closeTime"].forEach(function (fieldName) {
        var field = pickupForm.elements.namedItem(fieldName);

        if (!field) {
          return;
        }

        field.addEventListener("change", function () {
          syncPickupFieldValidity(pickupForm);
        });

        field.addEventListener("input", function () {
          syncPickupFieldValidity(pickupForm);
        });
      });
    }

    var buildLabelPayload = function (addressDecision) {
      var payload = normalizePayload(new FormData(form));

      var analytics = getGa4AnalyticsContext();
      if (analytics) {
        payload.analytics = analytics;
      }

      if (addressDecision) {
        payload.addressValidationDecision = addressDecision;
      }

      if (addressDecision === "use_suggested" && addressCandidates) {
        var selectedCandidate = pendingAddressCandidates[Number.parseInt(addressCandidates.value || "0", 10)];

        if (selectedCandidate) {
          payload.suggestedAddress1 = selectedCandidate.address1 || "";
          payload.suggestedAddress2 = selectedCandidate.address2 || "";
          payload.suggestedCity = selectedCandidate.city || "";
          payload.suggestedState = selectedCandidate.state || "";
          payload.suggestedPostalCode = selectedCandidate.postalCode || "";
          payload.suggestedCountryCode = selectedCandidate.countryCode || "US";
        }
      }

      return payload;
    };

    var submitLabelRequest = async function (addressDecision) {
      var payload = buildLabelPayload(addressDecision);

      hideStatus(status);
      if (!addressDecision) {
        resetAddressReview();
      }
      resetResult();

      if (!endpointUrl) {
        showStatus(status, "error", "Add the deployed API endpoint URL in the theme section settings first.");
        return;
      }

      if (!form.reportValidity()) {
        showStatus(status, "error", "Please complete all required fields before generating the label.");
        return;
      }

      if (addressDecision === "use_suggested" && !payload.suggestedAddress1) {
        showStatus(status, "error", "The verified address options are no longer available. Please try again.");
        return;
      }

      setButtonBusy(submitButton, true);
      setButtonBusy(useSuggestedAddressButton, true);

      try {
        activeAbortController = new window.AbortController();
        window.setTimeout(function () {
          if (activeAbortController) {
            activeAbortController.abort();
          }
        }, 45000);

        var response = await window.fetch(endpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
          signal: activeAbortController.signal
        });
        var data = await parseResponse(response);

        if (!response.ok) {
          if (data.errorCode === "address_selection_required" && Array.isArray(data.candidates) && data.candidates.length > 0) {
            renderAddressReview(payload, data);
            return;
          }

          throw new Error(withRequestId(data.error || "UPS label generation failed.", data.requestId));
        }

        resetAddressReview();

        const rawLabels = Array.isArray(data.labels) && data.labels.length > 0
          ? data.labels
          : (data.label && data.label.base64
            ? [
                {
                  packageNumber: 1,
                  trackingNumber: data.trackingNumber || "",
                  label: data.label
                }
              ]
            : []);

        if (rawLabels.length === 0) {
          throw new Error("UPS response did not include a printable label.");
        }

        labelUrls = rawLabels.map(function (entry, index) {
          const blob = base64ToBlob(entry.label.base64, entry.label.mimeType);

          return {
            packageNumber: entry.packageNumber || index + 1,
            trackingNumber: entry.trackingNumber || "",
            fileName: entry.label.fileName || ("ups-label-" + (index + 1)),
            url: window.URL.createObjectURL(blob)
          };
        });

        const requestedCount = Number.parseInt(String(data.packageCount || payload.packageCount || rawLabels.length || 1), 10);
        const labelSummaryCount = Number.isInteger(requestedCount) && requestedCount > 0
          ? requestedCount
          : rawLabels.length;
        const trackingNumbers = Array.isArray(data.trackingNumbers)
          ? data.trackingNumbers.filter(Boolean)
          : [];
        const combinedDocument = labelUrls.length === 1 && labelSummaryCount > 1;

        if (resultEyebrow) {
          resultEyebrow.textContent = labelSummaryCount === 1 ? "Label created" : "Labels created";
        }

        if (resultTitle) {
          resultTitle.textContent = labelSummaryCount === 1 ? "UPS label is ready" : "UPS labels are ready";
        }

        if (labelCount) {
          labelCount.textContent = labelSummaryCount === 1
            ? "1 label created"
            : labelSummaryCount + " labels created";
        }

        renderTrackingList(trackingList, trackingSummary, trackingNumbers);
        currentLabelTrackingNumbers = trackingNumbers.slice();
        renderLabelList(labelList, labelUrls, openPrintWindow, {
          summaryCount: labelSummaryCount,
          combinedDocument: combinedDocument
        });
        result.hidden = false;
        revealSection(result);
        rememberSender(payload, data.originAddress || null);

        // The label was made for the UPS verified address: show it in the form and the label drawing too,
        // so the next label does not ask to confirm the same address again. Set without events, which would reset the review.
        if (data.originAddress && data.originAddress.address1) {
          setFieldValue(form, "senderAddress1", data.originAddress.address1 || "");
          setFieldValue(form, "senderAddress2", data.originAddress.address2 || "");
          setFieldValue(form, "senderCity", data.originAddress.city || "");
          setFieldValue(form, "senderState", data.originAddress.state || "");
          setFieldValue(form, "senderPostalCode", data.originAddress.postalCode || "");
          updatePreview();
        }

        // Point "UPS Store or drop box" at UPS's list for the practice's city (UPS falls back to the state).
        var locationsLink = section.querySelector("[data-ups-locations-link]");
        var locationsAddress = data.originAddress || {};
        var locationsState = String(locationsAddress.state || payload.senderState || "").toLowerCase().replace(/[^a-z]/g, "");
        var locationsCity = String(locationsAddress.city || payload.senderCity || "").toLowerCase().replace(/[^a-z0-9]/g, "");

        if (locationsLink && locationsState.length === 2) {
          locationsLink.href = "https://locations.ups.com/us/en/" + locationsState + "/" + (locationsCity ? locationsCity + "/" : "");
        }

        // And the map link at the nearest UPS points around the office address.
        var mapLink = section.querySelector("[data-ups-map-link]");
        var mapAddress = [
          locationsAddress.address1 || payload.senderAddress1,
          locationsAddress.city || payload.senderCity,
          [locationsAddress.state || payload.senderState, locationsAddress.postalCode || payload.senderPostalCode].filter(Boolean).join(" ")
        ].filter(Boolean).join(", ");

        if (mapLink && mapAddress) {
          mapLink.href = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("UPS drop off near " + mapAddress);
          mapLink.textContent = "map near your office";
        }

        // The backend signs a void token for each new label; without one the cancel link stays hidden.
        currentVoidToken = data.voidToken || "";
        currentLabelRequestId = data.requestId || "";
        currentLabelPayload = payload;
        currentOriginAddress = data.originAddress || null;

        setVoidWording(labelSummaryCount);

        if (voidBlock) {
          voidBlock.hidden = !(currentVoidToken && voidLabelEndpointUrl);
        }
        primePickupForm(payload, {
          requestId: data.requestId,
          trackingNumber: data.trackingNumber || (labelUrls[0] && labelUrls[0].trackingNumber) || "",
          packageCount: data.packageCount || rawLabels.length,
          originAddress: data.originAddress || null
        });

        // The result header already says the label is ready; only a repeated request needs a note.
        if (data.duplicateRequest) {
          showStatus(
            status,
            "success",
            withRequestId(data.message || "This label request was already processed recently. Showing the latest label details.", data.requestId)
          );
        } else {
          hideStatus(status);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(status, "error", "The request timed out. Please try again.");
        } else {
          showStatus(status, "error", error.message || "Something went wrong while creating the UPS label.");
        }
      } finally {
        activeAbortController = null;
        setButtonBusy(submitButton, false);
        setButtonBusy(useSuggestedAddressButton, false);
      }
    };

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (section.classList.contains("is-returning") && !form.checkValidity()) {
        leaveReturning();
      }

      submitLabelRequest("");
    });

    if (useSuggestedAddressButton) {
      useSuggestedAddressButton.addEventListener("click", function () {
        submitLabelRequest("use_suggested");
      });
    }

    if (addressCandidates) {
      addressCandidates.addEventListener("change", function () {
        var selectedCandidate = pendingAddressCandidates[Number.parseInt(addressCandidates.value || "0", 10)];
        suggestedAddress.textContent = selectedCandidate ? formatAddressDisplay(selectedCandidate) : "";
      });
    }

    form.addEventListener("input", function () {
      if (pendingAddressCandidates.length > 0) {
        resetAddressReview();
      }
    });

    form.addEventListener("change", function () {
      if (pendingAddressCandidates.length > 0) {
        resetAddressReview();
      }
    });

    if (!pickupForm || !pickupSubmit) {
      return;
    }

    pickupForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      hideStatus(pickupStatus);

      if (pickupResult) {
        pickupResult.hidden = true;
      }

      if (pickupChargeRow) {
        pickupChargeRow.hidden = true;
      }

      if (!pickupEndpointUrl) {
        showStatus(pickupStatus, "error", "Pickup endpoint is not configured yet.");
        return;
      }

      if (!pickupForm.reportValidity()) {
        showStatus(pickupStatus, "error", "Please complete all required pickup fields first.");
        return;
      }

      var pickupGuardrailError = syncPickupFieldValidity(pickupForm);

      if (pickupGuardrailError) {
        showStatus(pickupStatus, "error", pickupGuardrailError.message);
        if (pickupGuardrailError.field && typeof pickupGuardrailError.field.reportValidity === "function") {
          pickupGuardrailError.field.reportValidity();
        }
        return;
      }

      setButtonBusy(pickupSubmit, true);

      try {
        activePickupAbortController = new window.AbortController();
        window.setTimeout(function () {
          if (activePickupAbortController) {
            activePickupAbortController.abort();
          }
        }, 45000);

        const payload = normalizePickupPayload(new FormData(pickupForm));
        payload.trackingNumbers = currentLabelTrackingNumbers;
        const response = await window.fetch(pickupEndpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
          signal: activePickupAbortController.signal
        });
        const data = await parseResponse(response);

        if (!response.ok) {
          throw new Error(withRequestId(data.error || "UPS pickup scheduling failed.", data.requestId));
        }

        currentPickupPrn = data.pickupConfirmationNumber || "";
        currentPickupCancelToken = data.cancelToken || "";
        pickupActive = Boolean(currentPickupPrn);
        setFieldValue(pickupForm, "pickupConfirmationNumber", currentPickupPrn);
        pickupPrn.textContent = currentPickupPrn || "Pending";

        if (data.chargeTotal && pickupCharge && pickupChargeRow) {
          pickupCharge.textContent = (data.chargeCurrency ? data.chargeCurrency + " " : "") + data.chargeTotal;
          pickupChargeRow.hidden = false;
        }

        // Cancelling needs the signed token the backend returns; without it the practice calls the lab.
        if (cancelPickupButton) {
          cancelPickupButton.hidden = !(currentPickupPrn && currentPickupCancelToken);
        }

        if (pickupResultEyebrow) {
          pickupResultEyebrow.textContent = "Pickup scheduled";
        }

        if (pickupResultTitle) {
          pickupResultTitle.textContent = "UPS pickup request confirmed";
        }

        pickupResult.hidden = false;

        // The pickup is booked: fold the form away and let the confirmation card speak for itself.
        var pickupToggle = pickupCard ? pickupCard.querySelector(".ups-pickup__toggle") : null;

        if (pickupToggle) {
          pickupToggle.open = false;
        }

        revealSection(pickupResult);

        if (data.duplicateRequest) {
          showStatus(
            pickupStatus,
            "success",
            withRequestId(data.message || "This pickup request was already processed recently. Showing the latest pickup details.", data.requestId)
          );
        } else {
          hideStatus(pickupStatus);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(pickupStatus, "error", "The pickup request timed out. Please try again.");
        } else {
          showStatus(pickupStatus, "error", error.message || "Something went wrong while scheduling the UPS pickup.");
        }
      } finally {
        activePickupAbortController = null;
        setButtonBusy(pickupSubmit, false);
      }
    });

    // Cancels the pickup scheduled on this page. Used by the Cancel Pickup button and when a label is voided.
    var requestPickupCancel = async function () {
      if (!cancelPickupEndpointUrl) {
        throw new Error("Cancel pickup endpoint is not configured yet.");
      }

      if (!currentPickupPrn) {
        throw new Error("Pickup confirmation number is missing.");
      }

      activeCancelPickupAbortController = new window.AbortController();
      window.setTimeout(function () {
        if (activeCancelPickupAbortController) {
          activeCancelPickupAbortController.abort();
        }
      }, 45000);

      try {
        const response = await window.fetch(cancelPickupEndpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            pickupConfirmationNumber: currentPickupPrn,
            cancelToken: currentPickupCancelToken,
            pickupDate: pickupForm.elements.namedItem("pickupDate").value || "",
            trackingNumber: pickupForm.elements.namedItem("trackingNumber").value || "",
            officeName: pickupForm.elements.namedItem("officeName").value || "",
            contactName: pickupForm.elements.namedItem("contactName").value || "",
            email: pickupForm.elements.namedItem("email").value || "",
            phone: pickupForm.elements.namedItem("phone").value || "",
            senderAddress1: pickupForm.elements.namedItem("senderAddress1").value || "",
            senderAddress2: pickupForm.elements.namedItem("senderAddress2").value || "",
            senderCity: pickupForm.elements.namedItem("senderCity").value || "",
            senderState: pickupForm.elements.namedItem("senderState").value || "",
            senderPostalCode: pickupForm.elements.namedItem("senderPostalCode").value || "",
            website: pickupForm.elements.namedItem("website").value || ""
          }),
          signal: activeCancelPickupAbortController.signal
        });
        const data = await parseResponse(response);

        if (!response.ok) {
          throw new Error(withRequestId(data.error || "UPS pickup cancel failed.", data.requestId));
        }

        pickupActive = false;

        if (pickupResultEyebrow) {
          pickupResultEyebrow.textContent = "Pickup cancelled";
        }

        if (pickupResultTitle) {
          pickupResultTitle.textContent = "UPS pickup request cancelled";
        }

        if (cancelPickupButton) {
          cancelPickupButton.hidden = true;
        }

        return data;
      } finally {
        activeCancelPickupAbortController = null;
      }
    };

    var showVoidedLabel = function (trackingNumbers) {
      result.classList.add("is-voided");

      if (resultCheck) {
        resultCheck.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M7 7l10 10M17 7 7 17"/></svg>';
      }

      var many = currentLabelCount > 1 || trackingNumbers.length > 1;

      if (resultEyebrow) {
        resultEyebrow.textContent = many ? "Labels cancelled" : "Label cancelled";
      }

      if (resultTitle) {
        resultTitle.textContent = many ? "Labels cancelled" : "Label cancelled";
      }

      if (labelCount) {
        labelCount.textContent = (trackingNumbers.length > 0
          ? "UPS voided " + trackingNumbers.join(", ") + ". "
          : (many ? "UPS voided these labels. " : "UPS voided this label. ")) +
          (many
            ? "Please don't use the printed copies. You can create new ones above."
            : "Please don't use the printed copy. You can create a new one above.");
      }

      if (voidBlock) {
        voidBlock.hidden = true;
      }

      // A pickup that is still active stays visible so it can be cancelled separately.
      if (pickupCard && !pickupActive) {
        pickupCard.hidden = true;
      }

      currentVoidToken = "";
      revokeLabelUrls(labelUrls);
      labelUrls = [];

      if (labelList) {
        labelList.innerHTML = "";
      }

      revealSection(result);
    };

    if (voidOpenButton && voidConfirm) {
      voidOpenButton.addEventListener("click", function () {
        hideStatus(voidStatus);

        if (voidPickupRow) {
          voidPickupRow.hidden = !pickupActive;
        }

        if (voidPickupCheckbox) {
          voidPickupCheckbox.checked = true;
        }

        if (voidPrompt) {
          voidPrompt.hidden = true;
        }

        voidConfirm.hidden = false;

        if (voidSubmit) {
          voidSubmit.focus();
        }
      });
    }

    if (voidKeepButton && voidConfirm) {
      voidKeepButton.addEventListener("click", function () {
        hideStatus(voidStatus);
        voidConfirm.hidden = true;

        if (voidPrompt) {
          voidPrompt.hidden = false;
        }

        if (voidOpenButton) {
          voidOpenButton.focus();
        }
      });
    }

    if (voidSubmit) {
      voidSubmit.addEventListener("click", async function () {
        var voidAbortController = null;
        var sender = currentLabelPayload || {};
        var origin = currentOriginAddress || {};

        hideStatus(voidStatus);

        if (!currentVoidToken || !voidLabelEndpointUrl) {
          showStatus(voidStatus, "error", "This label can't be cancelled from this page. Please call us at 877-335-5221.");
          return;
        }

        setButtonBusy(voidSubmit, true);

        if (voidKeepButton) {
          voidKeepButton.disabled = true;
        }

        try {
          voidAbortController = new window.AbortController();
          window.setTimeout(function () {
            voidAbortController.abort();
          }, 45000);

          const response = await window.fetch(voidLabelEndpointUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              voidToken: currentVoidToken,
              labelRequestId: currentLabelRequestId,
              officeName: sender.officeName || "",
              contactName: sender.contactName || "",
              email: sender.email || "",
              phone: sender.phone || "",
              senderAddress1: origin.address1 || sender.senderAddress1 || "",
              senderAddress2: origin.address2 || "",
              senderCity: origin.city || sender.senderCity || "",
              senderState: origin.state || sender.senderState || "",
              senderPostalCode: origin.postalCode || sender.senderPostalCode || "",
              website: ""
            }),
            signal: voidAbortController.signal
          });
          const data = await parseResponse(response);

          if (!response.ok) {
            throw new Error(withRequestId(data.error || "UPS could not cancel this label.", data.requestId));
          }

          // The label is voided first; its pickup, if the dentist asked, is cancelled after.
          var cancelPickupToo = pickupActive && voidPickupCheckbox && voidPickupCheckbox.checked;
          var pickupError = "";

          if (cancelPickupToo) {
            try {
              await requestPickupCancel();
            } catch (error) {
              pickupError = error.name === "AbortError" ? "The request timed out" : (error.message || "UPS pickup cancel failed");
            }
          }

          showVoidedLabel(Array.isArray(data.trackingNumbers) ? data.trackingNumbers.filter(Boolean) : []);

          if (pickupError) {
            showStatus(pickupStatus, "error", "The label is cancelled, but UPS did not cancel the pickup: " + trimTrailingPeriod(pickupError) + ". Try Cancel Pickup below.");
          }
        } catch (error) {
          if (error.name === "AbortError") {
            showStatus(voidStatus, "error", "The request timed out. Please try again.");
          } else {
            showStatus(voidStatus, "error", error.message || "Something went wrong while cancelling the UPS label.");
          }
        } finally {
          setButtonBusy(voidSubmit, false);

          if (voidKeepButton) {
            voidKeepButton.disabled = false;
          }
        }
      });
    }

    // A link from the label or pickup email: #cancel-label=<token> or #cancel-pickup=<token>.
    // The page only asks; nothing is cancelled until the dentist clicks, because mail scanners open links on their own.
    (function initCancelLink() {
      var card = section.querySelector("[data-ups-cancel-link]");

      if (!card || !window.URLSearchParams) {
        return;
      }

      var params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      var kind = params.has("cancel-pickup") ? "pickup" : (params.has("cancel-label") ? "label" : "");

      if (!kind) {
        return;
      }

      var token = params.get(kind === "pickup" ? "cancel-pickup" : "cancel-label") || "";
      var data = readCancelToken(token, kind === "pickup" ? "p1" : "v1");
      var title = card.querySelector("[data-ups-cancel-link-title]");
      var details = card.querySelector("[data-ups-cancel-link-details]");
      var text = card.querySelector("[data-ups-cancel-link-text]");
      var actions = card.querySelector("[data-ups-cancel-link-actions]");
      var submit = card.querySelector("[data-ups-cancel-link-submit]");
      var submitLabel = submit ? submit.querySelector("span") : null;
      var keep = card.querySelector("[data-ups-cancel-link-keep]");
      var linkStatus = card.querySelector("[data-ups-cancel-link-status]");
      var next = card.querySelector("[data-ups-cancel-link-next]");
      var close = card.querySelector("[data-ups-cancel-link-close]");
      var trackingNumbers = data && Array.isArray(data.t) ? data.t.filter(Boolean) : [];
      var many = kind === "label" && trackingNumbers.length > 1;
      var noun = kind === "pickup" ? "pickup" : (many ? "labels" : "label");
      var expired = !data || !Number.isFinite(data.e) || data.e <= Date.now();

      // Take the token out of the address bar so a reload or a shared screen does not offer it again.
      var dropLinkFromAddress = function () {
        try {
          window.history.replaceState(null, "", window.location.href.split("#")[0]);
        } catch (_error) {
          // Only the address bar is affected; the cancellation itself is done.
        }
      };

      var leave = function () {
        section.classList.remove("is-cancel-link");
        card.hidden = true;
        dropLinkFromAddress();
        revealSection(form);
      };

      var setText = function (element, value) {
        if (element) {
          element.textContent = value;
        }
      };

      section.classList.add("is-cancel-link");
      card.hidden = false;

      if (data) {
        setText(details, kind === "pickup"
          ? [data.o, formatPickupDate(data.d), data.p ? "Confirmation " + data.p : ""].filter(Boolean).join(" · ")
          : [data.o, trackingNumbers.length > 0 ? "Tracking " + trackingNumbers.join(", ") : ""].filter(Boolean).join(" · "));
      }

      if (!data || expired) {
        setText(title, !data
          ? "This link can't be used"
          : (kind === "pickup" ? "This pickup date has passed" : (many ? "These " : "This ") + noun + " can no longer be cancelled online"));
        setText(text, !data
          ? "Please call us at 877-335-5221 and we will help."
          : (kind === "pickup"
            ? "Please call us at 877-335-5221 if something still needs to change."
            : "Labels can be cancelled online for 24 hours after they are created. Please call us at 877-335-5221 and we will take care of it."));

        if (submit) {
          submit.hidden = true;
        }

        setText(keep, "Back to the label form");
      } else {
        setText(title, kind === "pickup"
          ? "Cancel this UPS pickup?"
          : (many ? "Cancel these " + trackingNumbers.length + " labels?" : "Cancel this label?"));
        setText(text, kind === "pickup"
          ? "UPS will not come for the boxes. Your labels stay valid, so you can still drop the boxes off at a UPS location."
          : (many
            ? "UPS will void them, and the printed labels will no longer work."
            : "UPS will void it, and the printed label will no longer work."));
        setText(submitLabel, "Yes, cancel " + noun);
        setText(keep, "Keep " + noun);
      }

      setText(close, kind === "pickup" ? "Back to the label form" : "Create a new label");

      if (keep) {
        keep.addEventListener("click", leave);
      }

      if (close) {
        close.addEventListener("click", leave);
      }

      if (submit) {
        submit.addEventListener("click", async function () {
          var endpoint = kind === "pickup" ? cancelPickupEndpointUrl : voidLabelEndpointUrl;
          var abortController = new window.AbortController();

          hideStatus(linkStatus);

          if (!endpoint) {
            showStatus(linkStatus, "error", "Online cancellation is not available right now. Please call us at 877-335-5221.");
            return;
          }

          setButtonBusy(submit, true);
          window.setTimeout(function () {
            abortController.abort();
          }, 45000);

          try {
            const response = await window.fetch(endpoint, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(kind === "pickup" ? { cancelToken: token, website: "" } : { voidToken: token, website: "" }),
              signal: abortController.signal
            });
            const result = await parseResponse(response);

            if (!response.ok) {
              throw new Error(result.error || "UPS could not cancel this " + noun + ".");
            }

            var cancelled = kind === "pickup"
              ? []
              : (Array.isArray(result.trackingNumbers) && result.trackingNumbers.length > 0 ? result.trackingNumbers : trackingNumbers);

            if (result.alreadyVoided || result.alreadyCancelled) {
              // A second click on the same email link: UPS already did it, nothing went wrong.
              setText(title, kind === "pickup"
                ? "This pickup was already cancelled"
                : (many ? "These labels were already cancelled" : "This label was already cancelled"));
              setText(text, kind === "pickup"
                ? "UPS will not come for it. Nothing else to do."
                : "UPS shows " + (many ? "them" : "it") + " as voided. Nothing else to do.");
            } else {
              setText(title, kind === "pickup" ? "Pickup cancelled" : (many ? "Labels cancelled" : "Label cancelled"));
              setText(text, kind === "pickup"
                ? "UPS will not come for this pickup. Your labels still work at any UPS location."
                : (cancelled.length > 0 ? "UPS voided " + cancelled.join(", ") + ". " : "") +
                  (many ? "Please don't use the printed copies." : "Please don't use the printed copy."));
            }

            if (actions) {
              actions.hidden = true;
            }

            if (next) {
              next.hidden = false;
            }

            dropLinkFromAddress();
          } catch (error) {
            showStatus(linkStatus, "error", error.name === "AbortError"
              ? "The request timed out. Please try again."
              : (error.message || "Something went wrong. Please call us at 877-335-5221."));
          } finally {
            setButtonBusy(submit, false);
          }
        });
      }

      revealSection(card);
    })();

    if (!cancelPickupButton) {
      return;
    }

    cancelPickupButton.addEventListener("click", async function () {
      hideStatus(pickupStatus);
      setButtonBusy(cancelPickupButton, true);

      try {
        const data = await requestPickupCancel();

        if (data.duplicateRequest) {
          showStatus(
            pickupStatus,
            "success",
            withRequestId(data.message || "This pickup cancellation was already processed recently.", data.requestId)
          );
        } else {
          hideStatus(pickupStatus);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(pickupStatus, "error", "The cancel request timed out. Please try again.");
        } else {
          showStatus(pickupStatus, "error", error.message || "Something went wrong while cancelling the UPS pickup.");
        }
      } finally {
        setButtonBusy(cancelPickupButton, false);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var sections = document.querySelectorAll("[data-ups-label-form]");
    if (sections.length) {
      loadCustomerPrivacyApi();
    }
    sections.forEach(initSection);
  });
})();
